import Flex from 'components/Flex'
import SidebarPage from 'components/SidebarPage'
import Nav from 'modules/Nav/Container/index'
import Header from 'modules/Page/Components/Partials/Header'
import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import styled from 'styled-components'
const { AUTH_URL } = process.env
// import { getTPOMetrics } from '../../TPORequests/actions'
import { useDispatch } from 'react-redux'

const BREAKPOINT = '999px'

const ContentWrapper = styled(Flex)`
  border-radius: 10px;

  &::-webkit-scrollbar {
    display: none;
  }
  width: 100%;
  display: block;
`
const PageWrapper = styled(Flex)`
  position: fixed;
  background: '#FFFFFF';
  flex-direction: column;
  height: 100vh;
  width: 100%;
  min-height: 100vh;
  flex-grow: 1;
  @media screen and (max-width: ${BREAKPOINT}) {
    padding: 0px;
    overflow-x: hidden;
    box-sizing: border-box;
  }
`
const BodyWrapper = styled(Flex)`
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
`

const Page = ({
  children,
  isOnboarding,
  userData,
  getUserInfo,
  userRole,
  getUserRoles,
  instituteData,
  getUserNotifications,
  getInstituteInfo,
  notificationData,
  markNotificationReadApi,
  getUserPermissions,
  signOut,
  checkOut,
  getTPOMetrics,
  studentsMetricsData,
}) => {
  const location = useLocation()
  const isJobPreview = location.pathname.includes('/jobPreview')
  const isTPODashboard = location.pathname.includes('/tpoDashboard')
  const dispatch = useDispatch()
  useEffect(() => {
    getUserInfo()
    getUserRoles()
    getTPOMetrics()
    studentsMetricsData()
  }, [])

  useEffect(() => {
    if (userData?.admin_role_id !== undefined) {
      getUserPermissions(userData?.admin_role_id)
    }
  }, [userData])

  return (
    !isOnboarding && (
      <PageWrapper>
        <Header
          userData={userData}
          userRole={userRole}
          instituteData={instituteData}
          getUserNotifications={getUserNotifications}
          notificationData={notificationData}
          markNotificationReadApi={markNotificationReadApi}
          signOut={signOut}
          checkOut={checkOut}
        />
        <BodyWrapper>
          <Nav />
          <SidebarPage padding={isJobPreview || isTPODashboard}>
            <ContentWrapper>{children}</ContentWrapper>
          </SidebarPage>
        </BodyWrapper>
      </PageWrapper>
    )
  )
}
export default Page
